import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import NavBar from './Components/NavBar/NavBar';
import Projects from './Components/Projects/Projects';
import Blogs from './Components/Blogs/Blogs';
import ContactPage from './Page/HomePage/ContactPage/ContactPage';
import AboutPage from './Page/HomePage/AboutPage/AboutPage';
import AllHomePage from './Page/AllHomePage/AllHomePage';
import NotFound from './Components/NotFound/NotFound';

function App() {
  return (
    <>
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <AllHomePage></AllHomePage>
            </Route>
            <Route path="/navbar">
              <NavBar></NavBar>
            </Route>
            <Route path="/about">
              <AboutPage></AboutPage>
            </Route>
            <Route path="/projects">
              <Projects></Projects>
            </Route>
            <Route path="/blogs">
              <Blogs></Blogs>
            </Route>
            <Route path="/contact">
              <ContactPage></ContactPage>
            </Route>
            <Route path="*">
              <NotFound></NotFound>
            </Route>
          </Switch>
        </div>
      </Router>



    </>
  );
}

export default App;
